import { Link } from 'react-router-dom';
import type { Comic } from '@/types/comic';
import ComicCard from '@/components/feature/ComicCard';

interface ComicGridSectionProps {
  title: string;
  subtitle?: string;
  comics: Comic[];
  moreTo?: string;
  moreLabel?: string;
  className?: string;
}

export default function ComicGridSection({
  title,
  subtitle,
  comics,
  moreTo,
  moreLabel = '查看更多',
  className = '',
}: ComicGridSectionProps) {
  return (
    <section className={`mx-auto max-w-7xl px-4 py-8 md:px-6 md:py-10 ${className}`}>
      <div className="mb-6 flex items-end justify-between gap-4">
        <div>
          <h2 className="flex items-center gap-2 text-xl font-bold text-foreground-950 md:text-2xl">
            <span className="h-5 w-1 rounded-full bg-accent-500" />
            {title}
          </h2>
          {subtitle && <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>}
        </div>
        {moreTo && (
          <Link
            to={moreTo}
            className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm text-primary-600 transition-colors hover:text-primary-700"
          >
            {moreLabel}
            <i className="ri-arrow-right-s-line" />
          </Link>
        )}
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-5">
        {comics.map((c) => (
          <ComicCard key={c.id} comic={c} />
        ))}
      </div>
    </section>
  );
}